var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewAs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 48,
    viewBox: "0 0 78 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container",
    width: 18,
    height: 18,
    transform: "translate(0 0)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6935",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-2",
    "data-name": "container",
    width: 18,
    height: 18,
    transform: "translate(0 0)",
    fill: "#206bdd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10160",
    "data-name": "Group 10160",
    transform: "translate(-1156 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6934",
    "data-name": "Rectangle 6934",
    width: 73,
    height: 38,
    rx: 3,
    transform: "translate(1161)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10165",
    "data-name": "Group 10165",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10161",
    "data-name": "Group 10161",
    transform: "translate(1200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6935-2",
    "data-name": "Rectangle 6935",
    width: 30,
    height: 30,
    rx: 3,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(6 6)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10163",
    "data-name": "Group 10163",
    transform: "translate(3.051 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M6.073,17c-.117,0-.233-.108-.365-.342-.631-1.124-1.893-3.282-1.9-3.3-.333-.536-.7-1.066-1.086-1.626l0-.005A17.881,17.881,0,0,1,.357,7.569a5.756,5.756,0,0,1,.32-4.716A5.043,5.043,0,0,1,2.845.732,6.574,6.574,0,0,1,5.893,0a5.752,5.752,0,0,1,5.063,2.707,5.981,5.981,0,0,1,.665,5.015,16.06,16.06,0,0,1-2.356,4.263c-.329.477-.638.923-.926,1.375-.008.013-1.27,2.208-1.887,3.287C6.316,16.885,6.192,17,6.073,17ZM5.949,3.4a2.338,2.338,0,1,0,2.34,2.335A2.338,2.338,0,0,0,5.949,3.4Z",
    fill: "#b5b5b5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10159",
    "data-name": "Group 10159",
    transform: "translate(1165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_6935)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6935-3",
    "data-name": "Rectangle 6935",
    width: 30,
    height: 30,
    rx: 3,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pin-2",
    "data-name": "pin",
    transform: "translate(6 6)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10162",
    "data-name": "Group 10162",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6936",
    "data-name": "Rectangle 6936",
    width: 6.4,
    height: 6.4,
    rx: 1,
    fill: "#206bdd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6937",
    "data-name": "Rectangle 6937",
    width: 6.4,
    height: 6.4,
    rx: 1,
    transform: "translate(9.6)",
    fill: "#206bdd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6938",
    "data-name": "Rectangle 6938",
    width: 6.4,
    height: 6.4,
    rx: 1,
    transform: "translate(9.6 9.6)",
    fill: "#206bdd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6939",
    "data-name": "Rectangle 6939",
    width: 6.4,
    height: 6.4,
    rx: 1,
    transform: "translate(0 9.6)",
    fill: "#206bdd"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAs);
export default __webpack_public_path__ + "static/media/view_as.3238f9c16dc889afbfffe50cc182a41e.svg";
export { ForwardRef as ReactComponent };